export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL,
  SIGN_IN_URL: process.env.REACT_APP_SIGN_IN_URL,
  VENDOR_URL: process.env.REACT_APP_VENDOR_URL,
  CHAT_URL: process.env.REACT_APP_CHAT_URL,
  TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT, 10) || 5000,
};